import * as React from 'react';
const PageList = (props) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7 1H3C1.89543 1 1 1.89543 1 3V15C1 16.1046 1.89543 17 3 17H7M7 1H15C16.1046 1 17 1.89543 17 3V15C17 16.1046 16.1046 17 15 17H7M7 1V17"
      stroke="#071C3E"
      strokeWidth={1.5}
    />
    <rect x={3} y={4} width={2} height={2} rx={0.5} fill="#071C3E" />
    <rect x={3} y={8} width={2} height={2} rx={0.5} fill="#071C3E" />
    <rect x={3} y={12} width={2} height={2} rx={0.5} fill="#071C3E" />
  </svg>
);
export default PageList;
